import React from "react";

import { Col, Image, Row } from "react-bootstrap";
import AppNavbar from "../../components/common/AppNavbar";

const Goa = () => {
  const Beach = [
    {
      title: "Baga Beach",
      image:
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/18/3e/36/95/baga-sea-beach.jpg?w=800&h=500&s=1",
      content:
        "Baga beach is the most busiest beach here in Goa and most lively beaches in north goa.",
    },
    {
      title: "Benaulim Beach",
      image:
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/66/b5/10/benaulim-beach.jpg?w=1200&h=800&s=1",
      content: "Quite and calm beach is away from the village in south Goa.",
    },
    {
      title: "Candolim Beach",
      image:
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/17/d6/cd/d6/candolim-beach.jpg?w=600&h=600&s=1",
      content: "Great place to see a sunset while chilling",
    },
    {
      title: "Palolem Beach",
      image:
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/12/59/82/3a/beach-attached-to-the.jpg?w=600&h=600&s=1",
      content: "One of the area's most picturesque beaches.",
    },
  ];
  const Temples = [
    {
      title: "Mangeshi Temple",
      image:
        "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/49/d0/cd/img-20181107-235325-largejpg.jpg?w=1000&h=700&s=1",
    },
    {
      title: "Basilica of Bom Jesus",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQigBCzxbWnGgxqDwAdgJA_GG3egQSSeMcKwg&s",
    },
    {
      title: "Shri Mahalasa Temple",
      image:
        "https://itsgoa.com/wp-content/uploads/2024/08/mahalasa-temple-verna-goa-4-1024x709.jpeg",
    },
    {
      title: "Shantadurga Temple",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDd4dr84HEX_i4xEwKRfqCRv9Fk3-9TII_zNWoynGgYbgBm0lmK5a7GosoMliEf7jyhDI&usqp=CAU",
    },
  ];
  return (
    <>
      <AppNavbar />
      <div className="banner">
        <div className="banner-content">
          <iframe
            src="https://www.youtube.com/embed/kFPTkmQX7JA?autoplay=1&mute=1&loop=1&playlist=kFPTkmQX7JA&controls=0&showinfo=0&modestbranding=1"
            title="Goa Fullscreen Banner"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          ></iframe>
        </div>
        <div className="banner-text">
          <h2 className="animate-fade">Welcome to Goa</h2>
          <p className="animate-fade">
            Explore the beauty and culture of India’s beach paradise.
          </p>
        </div>
      </div>

      <div className="py-4">
        <div className="container">
          <Row>
            <Col className="d-flex align-items-center justify-content-center">
              <div>
                {" "}
                <h4 className="fw-bold">
                  Discover India's coastal jewel Goa: Where the sun, sand, and
                  susegad collide
                </h4>
                <p>
                  Ah, Goa! The very name conjures up images of sun-kissed
                  beaches, swaying palm trees, and a laid-back vibe that is as
                  contagious as a beachside melody. Let's dive into this coastal
                  paradise and explore its magic.
                </p>
              </div>
            </Col>
            <Col>
              <div className="ratio ratio-21x9" style={{ height: "200" }}>
                <iframe
                  title="Goa"
                  className="rounded"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d984956.6955125841!2d73.34710415087919!3d15.350084408335885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfba106336b741%3A0xeaf887ff62f34092!2sGoa!5e0!3m2!1sen!2sin!4v1748428963611!5m2!1sen!2sin"
                  style={{ border: "0" }}
                  allowFullScreen
                ></iframe>
              </div>
            </Col>
          </Row>
          <hr />
          <div className="py-4">
            <h3 className="my-4 fw-bold">Beaches To Go</h3>
            <Row>
              {Beach.map((item, index) => (
                <Col key={index} xs={12} sm={6} md={4} lg={6} className="mb-4">
                  <div className="yacht-tile">
                    <img src={item.image} alt={item.title} />
                    <div className="overlay">
                      <h3>{item.title}</h3>
                    </div>
                  </div>
                  <p className="mt-3 ">{item.content}</p>
                </Col>
              ))}
            </Row>
          </div>
          <small className="text-center">Advertisement</small>
          <Image
            src="https://platforms.makemytrip.com/contents/16b311c3-7539-4380-a655-e47dc48e1f49"
            alt=""
            fluid
            className="rounded"
          />
          <hr />
          <div className="">
            <h3 className="my-4 fw-bold">Holy shrines</h3>
            <Row>
              {Temples.map((item, index) => (
                <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                  <div className="yacht-tile">
                    <img src={item.image} alt={item.title} />
                    <div className="overlay">
                      <h3>{item.title}</h3>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          <small className="text-center">Advertisement</small>
          <Image
            src="https://platforms.makemytrip.com/contents/16b311c3-7539-4380-a655-e47dc48e1f49"
            alt=""
            fluid
            className="rounded"
          />
        </div>
      </div>
    </>
  );
};

export default Goa;
